import Vue from 'vue';
import Vuex from 'vuex';

import user from './modules/user';
import enrollments from './modules/enrollments';
import enrollment from './modules/enrollment';
import registrations from './modules/registrations';
import registration from './modules/registration';
import conference from './modules/conference';
import categories from './modules/categories';

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {user, enrollments, enrollment, registrations, registration, conference, categories},
    state: {
        sidePanel: {
            minimized: false,
            details: true,
            submenu: false
        },
        colors: {
            primary: '#336699',
            background1: '#336699',
            background2: '#213f6a',
        }
    },
    getters: {
        sidePanel: state => state.sidePanel,
        colors: state => state.colors,
    },
    mutations: {
        setMinimized(state, payload) {
            state.sidePanel.minimized = payload;
        },
        setDetails(state, payload) {
            state.sidePanel.details = payload;
        },
        setSubmenu(state, payload) {
            state.sidePanel.submenu = payload;
        },
        setColors(state, payload) {
            // state.colors.primary = payload.primary;
            // state.colors.background1 = payload.background1;
            // state.colors.background2 = payload.background2;
        }
    }
});
